import { connect } from 'react-redux';
import { compose, hoistStatics, lifecycle, withState } from 'recompose';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import moment from 'moment';

import Layout from './Layout';
import ml from '../../helpers/ml.helper';
import { authActions } from '../../reducers/auth';
import { userActions } from '../../reducers/user';
import PageService from '../../services/page.service';
import AuthService from '../../services/auth.service';
import WithLoading from '../../components/WithLoading';
import { moduleActions } from '../../reducers/modules';
import { settingsActions } from '../../reducers/settings';
import LanguageService from '../../services/language.service';
import { permissionsActions } from '../../reducers/permissions';
import ModuleService from '../../services/module.service';
import CustomLink from '../../services/customLink.service';
import Youtube from '../../services/youtube.service';
import VimeoService from '../../services/vimeo.service';
import { wsOperations } from '../../reducers/websockets';
import Loading2 from '../../components/Loading2';

const mapStateToProps = state => ({
  user: state.user.user,
  subscriber: state.settings.subscriber,
  token: state.auth.token,
  langLength: state.settings.langs.length,
  permissions: state.permissions,
  modulesTypes: state.modules.modulesTypes,
  hasLoadedPage: state.settings.hasLoadedPage,
  defaultRoute: state.settings.defaultRoute,
  intercomId: state.modules.modulesSettings.intercom ? state.modules.modulesSettings.intercom.params.appId : '',
});

const mapDispatchToProps = {
  setUser: userActions.setUser,
  clearToken: authActions.clearToken,
  setModules: moduleActions.setModules,
  setPagesLinks: moduleActions.setPagesLinks,
  setCustomLinks: moduleActions.setCustomLinks,
  setYoutube: moduleActions.setYoutube,
  setVimeo: moduleActions.setVimeo,
  updateSettings: settingsActions.updateSettings,
  setPermissions: permissionsActions.setPermissions,
  connectSocketToServer: wsOperations.connectSocketToServer,
  unsubscribeToChannel: wsOperations.unsubscribeToChannel,
  subscribeToChannel: wsOperations.subscribeToChannel,
};

const setModulesData = async ({ setPagesLinks, setCustomLinks, setYoutube, setModules, modulesTypes = [], setVimeo }) => {
  let modules = modulesTypes;
  if (!modules.length) {
    const { data } = await ModuleService.getData({ installed: true });
    setModules(data);
    modules = data.map(({ type }) => type);
  }

  if (modules.includes(ModuleService.TYPE_PAGE)) {
    const resp = await PageService.getAll();
    setPagesLinks(resp);
  }
  if (modules.includes(ModuleService.TYPE_LINK)) {
    const resp = await CustomLink.getData();
    setCustomLinks(resp.data);
  }
  if (modules.includes(ModuleService.TYPE_YOUTUBE)) {
    const resp = await Youtube.getData();
    setYoutube(resp.data);
  }
  if (modules.includes(ModuleService.TYPE_VIMEO)) {
    const resp = await VimeoService.getData();
    setVimeo(resp.data);
  }
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('isLoading', 'setIsLoading', true),
  withState('intercom', 'setIntercom', null),
  translate('portal'),
  lifecycle({
    async componentDidMount() {
      const { props } = this;
      const { user: storedUser,
        subscribeToChannel,
        connectSocketToServer,
        ...rest
      } = props;
      let user = storedUser;
      let forseUpdate = false;
      if (!user) {
        try {
          await AuthService.setToken(props.token);
          const { user: currentUser, permissions } = await AuthService.getCurrentUser();
          user = currentUser;
          forseUpdate = true;
          connectSocketToServer();
          subscribeToChannel('common');
          if (user.language !== 'en')moment.locale('fr');
          else moment.locale('en');
          await props.setUser({ user });
          await props.setPermissions(permissions);
        } catch (e) {
          await props.clearToken();
        }
      } else if (user.language !== 'en')moment.locale('fr');
      else moment.locale('en');
      if (props.langLength === 0) {
        props.updateSettings(await LanguageService.getSettings());
      }
      const language = ml.getLanguage(user, props.subscriber, props.defaultLanguage);
      if (forseUpdate || language !== props.i18n.language) {
        ml.changeLanguage(props.i18n, language);
      }

      await setModulesData(rest);
      await props.setIsLoading(false);
    },
  }),
);

export default withRouter(hoistStatics(enhance)(WithLoading(Layout, Loading2)));



// WEBPACK FOOTER //
// ./src/containers/layout/index.js